/* Converts typed amounts (snippets/fixed-price.liquid) into the shopper's currency.
   Shopify exposes the active presentment currency and its rate against the store
   currency on every storefront page as Shopify.currency = {active, rate}. Product
   prices are converted by Shopify itself; this covers only amounts entered by hand
   in the theme editor (Patreon, community membership, 1:1 ranges). */
(function(){
  function run(root){
    var c = window.Shopify && window.Shopify.currency;
    if(!c || !c.active) return;
    var rate = parseFloat(c.rate || '1');
    if(!(rate > 0)) return;
    var lang = document.documentElement.lang || 'en';
    var fmt;
    try { fmt = new Intl.NumberFormat(lang, {style: 'currency', currency: c.active, minimumFractionDigits: 2, maximumFractionDigits: 2}); }
    catch(e){ return; }
    var nodes = (root || document).querySelectorAll('.fixed-price[data-cents]:not([data-converted])');
    for(var i = 0; i < nodes.length; i++){
      var cents = parseInt(nodes[i].getAttribute('data-cents'), 10);
      if(isNaN(cents)) continue;
      nodes[i].textContent = fmt.format(cents / 100 * rate);
      nodes[i].setAttribute('data-converted', '1');
    }
  }
  window.convertFixedPrices = run;
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(); });
  else run();
  document.addEventListener('shopify:section:load', function(e){ run(e.target); });
})();
